/*
*
* File JS componente Scroll Banner
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './scroll-banner.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const manageAnimation = () => {
    let triggerEl = document.querySelector('.block-scrollbanner');

    if (!triggerEl) return;

    let sceneHero = null;
    let controller = new ScrollMagic.Controller();
    let durationScene = triggerEl.offsetHeight / 2;

    sceneHero = new ScrollMagic.Scene({
        triggerElement: triggerEl,
        offset: durationScene,
        triggerHook: 1,
        duration: durationScene
    })
    // .addIndicators()
    .on('progress', function(evt){

        // let clipValue = 100 - (evt.progress * 100);

        // triggerEl.querySelector('.block-scrollbanner__wrap').style.clipPath = `circle(${clipValue}%)`;
    })
    .addTo(controller);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const scrollBanner = () => {

    manageAnimation();

}

export default scrollBanner;

//--------------------------------------------------------------------//